import { DialogProps } from '@mui/material'
import { useEffect, useState } from 'react'
import { DropzoneOptions } from 'react-dropzone'
import { UploadFile } from '~/@/components/inputs/file/upload-file'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { LoadingButton } from '~/components/ui/molecules/loading-button/LoadingButton'
import { Modal } from '../ui/molecules/modal/Modal'

export interface DropzoneDialogProps {
  dialogProps: Omit<DialogProps, 'onClose'>
  dropzoneOptions: DropzoneOptions
  onCancel?: () => void
  onDone: (files: File[]) => void
  allowMultiple: boolean
  isUploading?: boolean
}

export const DropzoneDialog = ({
  dialogProps,
  dropzoneOptions,
  onCancel,
  onDone,
  allowMultiple,
  isUploading,
}: DropzoneDialogProps) => {
  const { t } = useTypedTranslation()
  const [files, setFiles] = useState<Record<string, File>>({})

  useEffect(() => {
    if (dialogProps.open) {
      setFiles({})
    }
  }, [dialogProps.open])

  const handleDone = () => {
    onDone(Object.values(files))
  }

  const handleCancel = () => {
    onCancel?.()
    setFiles({})
  }

  return (
    <Modal
      actions={
        <LoadingButton
          disabled={Object.keys(files).length === 0}
          loading={isUploading ?? false}
          onClick={handleDone}
          size="small"
          variant="secondary"
        >
          {t('dropzone.upload')}
        </LoadingButton>
      }
      fullWidth
      onClose={handleCancel}
      title={t('dropzone.upload_file')}
      {...dialogProps}
    >
      <UploadFile
        allowMultiple={allowMultiple}
        dropzoneOptions={dropzoneOptions}
        files={files}
        setFiles={setFiles}
      />
    </Modal>
  )
}
